<template>
  <div class="main">


<GainCharts></GainCharts>
  </div>
</template>

<script>
import { mapMutations, mapGetters, mapActions } from "vuex";
import SearchBar from "@/components/common/NewSearchBar.vue";
import Permissions from "@/store/permissions.js";
import { formatDate, strToFormatDate } from "@/plugins/DateTimeFormater.js";
import New4Index2 from "@/components/charts/New4Index2.vue";
import GainCharts from "@/components/charts/GainCharts.vue";
import new4i from "@/store/local_data/new4index.js"
export default {
  name: "equipnalysis",
  components: {
    SearchBar,
    GainCharts
  },
  data() {
    return {
      viewResult: false,
      currentModuleName: "EquipAnalysis",
      t:'整市场价格指数'
  }
   
  },
  mounted(){
    let js = new4i.new4index.filter(x=>{return x.t==this.t && x.date.indexOf('2020')>=0 }).map(z=>z.value);
   // alert(JSON.stringify(js));
  },
  methods: {
    exportExcel() {},
  },
 
 
};
</script>
